import script_nc2 from "./script_nc2";
import { toast } from "react-toastify";
import { Nc2BlockUser,nc2ScheduleNumbersUser,nc2ScheduleReasonsUser } from '.';

var checkType = true;

export const nc2Service = (function ()
{

// ================= abaixo da camargo
// const NC2_URL_BASE = 'http://192.168.201.251:8080';
// const NC2_URL = NC2_URL_BASE + '/nc2service/rest/putJsonMessage';
// const NC2_URL_LOGIN_CLOUD = NC2_URL_BASE + '/nc2cloud/_login';
// const NC2_URL_LOGOFF_CLOUD= NC2_URL_BASE + '/nc2cloud/nc2/user/logoffService'
// const NC2_URL_CALLBACK = NC2_URL_BASE + '/nc2cloud/nc2/callback/userCallBack';
// const NC2_URL_OPERADOR = NC2_URL_BASE + '/nc2cloud/nc2/oper/getOperador?ramal=';
// const NC2_URL_CHECKDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkDataService';
// const NC2_URL_CHECKCOMPLEXDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkComplexDataService';
// const NC2_URL_ATUALIZA_PROSPECT = NC2_URL_BASE + '/nc2cloud/nc2/user/atualizaProspectService';
// const NC2_URL_RESULTADOS = NC2_URL_BASE + '/nc2cloud/nc2/user/selectResultadosService?idprojeto=';
// const NC2_URL_TELEFONES = NC2_URL_BASE + '/nc2cloud/nc2/user/selectTelefonesService?idprospect=';


// ================= abaixo da ingenium com https
  // const NC2_URL_BASE = 'https://netcenter-vm.ddns.net:5181';
  // const NC2_URL = NC2_URL_BASE + '/nc2service/rest/putJsonMessage';
  // const NC2_URL_LOGIN_CLOUD = NC2_URL_BASE + '/nc2cloud/_login';
  // const NC2_URL_LOGOFF_CLOUD= NC2_URL_BASE + '/nc2cloud/nc2/user/logoffService'
  // const NC2_URL_CALLBACK = 'https://192.168.10.6:8181' + '/nc2cloud/nc2/callback/userCallBack';
  // const NC2_URL_OPERADOR = NC2_URL_BASE + '/nc2cloud/nc2/oper/getOperador?ramal=';
  // const NC2_URL_CHECKDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkDataService';
  // const NC2_URL_CHECKCOMPLEXDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkComplexDataService';
  // const NC2_URL_ATUALIZA_PROSPECT = NC2_URL_BASE + '/nc2cloud/nc2/user/atualizaProspectService';
  // const NC2_URL_RESULTADOS = NC2_URL_BASE + '/nc2cloud/nc2/user/selectResultadosService?idprojeto=';
  // const NC2_URL_TELEFONES = NC2_URL_BASE + '/nc2cloud/nc2/user/selectTelefonesService?idprospect=';

  // ================= abaixo da ingenium ssem https
  const NC2_URL_BASE = 'http://netcenter-vm.ddns.net:5080';
  const NC2_URL = NC2_URL_BASE + '/nc2service/rest/putJsonMessage';
  const NC2_URL_LOGIN_CLOUD = NC2_URL_BASE + '/nc2cloud/_login';
  const NC2_URL_LOGOFF_CLOUD= NC2_URL_BASE + '/nc2cloud/nc2/user/logoffService'
  const NC2_URL_CALLBACK = 'http://192.168.10.6:8080' + '/nc2cloud/nc2/callback/userCallBack';
  const NC2_URL_OPERADOR = NC2_URL_BASE + '/nc2cloud/nc2/oper/getOperador?ramal=';
  const NC2_URL_CHECKDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkDataService';
  const NC2_URL_CHECKCOMPLEXDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkComplexDataService';
  const NC2_URL_ATUALIZA_PROSPECT = NC2_URL_BASE + '/nc2cloud/nc2/user/atualizaProspectService';
  const NC2_URL_RESULTADOS = NC2_URL_BASE + '/nc2cloud/nc2/user/selectResultadosService?idprojeto=';
  const NC2_URL_TELEFONES = NC2_URL_BASE + '/nc2cloud/nc2/user/selectTelefonesService?idprospect=';

// =============== abaixo da lippaus
// const NC2_URL_BASE = 'http://192.168.0.8:8080';
// const NC2_URL = NC2_URL_BASE + '/nc2service/rest/putJsonMessage';
// const NC2_URL_LOGIN_CLOUD = NC2_URL_BASE + '/nc2cloud/_login';
// const NC2_URL_LOGOFF_CLOUD= NC2_URL_BASE + '/nc2cloud/nc2/user/logoffService'
// const NC2_URL_CALLBACK = NC2_URL_BASE + '/nc2cloud/nc2/callback/userCallBack';
// const NC2_URL_OPERADOR = NC2_URL_BASE + '/nc2cloud/nc2/oper/getOperador?ramal=';
// const NC2_URL_CHECKDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkDataService';
// const NC2_URL_CHECKCOMPLEXDATA = NC2_URL_BASE + '/nc2cloud/nc2/user/checkComplexDataService';
// const NC2_URL_ATUALIZA_PROSPECT = NC2_URL_BASE + '/nc2cloud/nc2/user/atualizaProspectService';
// const NC2_URL_RESULTADOS = NC2_URL_BASE + '/nc2cloud/nc2/user/selectResultadosService?idprojeto=';
// const NC2_URL_TELEFONES = NC2_URL_BASE + '/nc2cloud/nc2/user/selectTelefonesService?idprospect=';
  

//Status do operador
const STATUS_OPERADOR_LIVRE = 0;
const STATUS_OPERADOR_OCUPADO = 1;
const STATUS_OPERADOR_PAUSA = 2;
const STATUS_OPERADOR_ACW = 5;
const STATUS_OPERADOR_PREVIEW = 6;

//Modo de encerramento
const ENCERRAR_CONTATO = 0;
const ENCERRAR_CONTATO_PAUSA = 1;
const ENCERRAR_CONTATO_LOGOFF = 2;
const ENCERRAR_CONTATO_PREVIEW = 3;
const ENCERRAR_CONTATO_REAGENDAR = 4;

localStorage.setItem('nc2SessionKey', '');
localStorage.setItem('nc2Seq',1);
localStorage.setItem('operador', null);
localStorage.setItem('nc2Logado',false);
localStorage.setItem('isCheckData', false);
localStorage.setItem('isCheckMessage',true);
localStorage.setItem('loginCloud', false);
localStorage.setItem('loginCore' , false);
localStorage.setItem('nc2CheckDataDto',null);
localStorage.setItem('nc2UserData',null);
localStorage.setItem('fone',0);


// timers
var checkDataTimer = null;
var mensagemTimer = null;

  function nc2MonitoraService(pRamal, dispatch){
    /* Transferencia Timer */
    checkDataTimer = setInterval(function() {


        if (nc2Operador() != null && isCheckData() && nc2Logado()) {
            //Define variaveis    
            var xhttp = new XMLHttpRequest();

            //Incrementa sequencia
            nc2IncrementaSequence();

          
            xhttp.open("GET", NC2_URL_CHECKDATA + '?ramal=' + nc2Operador().loginPABX, false);
            xhttp.send();

                if (xhttp.readyState == 4 && xhttp.status == 200) {  
                    
                    if (xhttp.responseText != null) {

                    localStorage.setItem('nc2CheckDataDto', JSON.stringify(JSON.parse(xhttp.responseText).dto));

                    
                    if(nc2CheckDataDto().isTerminarConexao === true){
                        toast.dismiss();
                        localStorage.setItem('isCheckData',false);
                        nc2ReconectarService(nc2Operador().loginPABX);
                        /*
                        toast.info(''+ nc2CheckDataDto().msgTerminarConexao, {
                            position: "bottom-right",
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        });
                        */
                        
                        return true;
                    }

                    if (nc2CheckDataDto().statusOperador == STATUS_OPERADOR_OCUPADO){

                       
                        localStorage.setItem('isCheckData', false);
                        
                        nc2AlteraStatus(nc2Operador().loginPABX,STATUS_OPERADOR_OCUPADO);
                        script_nc2.onScreenView(nc2CheckDataDto(),nc2Operador().loginPABX,dispatch)
                        
                        toast.dismiss();
                        localStorage.setItem('fone',0);

                        // setTimeout(() => {
                        //   nc2Service.nc2ObterTelefones(dispatch)
                        //   nc2Service.nc2ObterResultados(dispatch)
                        // }, 2000)
                    } else if (nc2CheckDataDto().fone != null && nc2CheckDataDto().fone != "" && (nc2CheckDataDto().statusMsg === null || nc2CheckDataDto().statusMsg === "")) { // Discando para um contato.
                        if(nc2CheckDataDto().fone !== localStorage.getItem('fone')){
                          toast.dismiss();
                          toast.info('Discando para '+ nc2CheckDataDto().fone, {
                              position: "bottom-right",
                              hideProgressBar: true,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined
                          });
                          localStorage.setItem('fone',nc2CheckDataDto().fone) ;
                        }
                    } else if(nc2CheckDataDto().statusMsg === 'Agente em pausa - Estado Inconsistente'){
                      toast.dismiss();
                      localStorage.setItem('isCheckData',false);
                      dispatch(Nc2BlockUser(true,'Estado Inconsistente'));
                      return true;
                      
                    } else if(nc2CheckDataDto().statusMsg === 'Agente em pausa - Não há mais prospects disponíveis no banco de dados'){
                        toast.dismiss();
                        localStorage.setItem('isCheckData',false);
                        dispatch(Nc2BlockUser(true,'Sem mailing'));
                        return true;
                    }
					
                    return true;                        
                }
                
            }
        }    
    
    }, 4000);
    
    
  }

function nc2EncerraContato(ramal,tempoContato,especifica, resultado, proximaligacao,telefone){    
  //Define variaveis
  var urlInformaMotivoPausa = NC2_URL + '?sessionKey=' + localStorage.getItem('nc2SessionKey') + '&jsonMsg={"sequence":"' + localStorage.getItem('nc2Seq') + '","type":1025,"arguments":{"ramal":"'+ ramal +'","projeto":"' + nc2CheckDataDto().prospect.projeto.idProjeto + '","campanha":"' + nc2CheckDataDto().prospect.campanha.idCampanha  +'","prospect":"' + nc2CheckDataDto().prospect.idProspect + '","resultado":"' + resultado + '","tempo":"' + tempoContato + '","codigoOperador":"' + nc2CheckDataDto().operador.idOperador + '","telefone":" ' + telefone + '","especifica":' + especifica + ',"proxima":"' + proximaligacao +  '","tipo":"' + nc2CheckDataDto().tipo + '","pa":"' + ramal + '","acw":' + nc2CheckDataDto().acwCode +',"desligou":false}}';
  var xhttp = new XMLHttpRequest();
    
    //Incrementa sequencia
    nc2IncrementaSequence();

    xhttp.open("GET", urlInformaMotivoPausa, false);
    xhttp.send();

     
    if (xhttp.readyState == 4 && xhttp.status == 200) {          
        return true;
        
    }
   
}

function nc2AtualizaProspect(ramal){
  //Define variaveis
  var urlInformaMotivoPausa = NC2_URL_ATUALIZA_PROSPECT + '?idProspect=' + nc2CheckDataDto().prospect.idProspect + '&qtdAgOperador=' + nc2CheckDataDto().prospect.qtdeagoperador + '&status=' + nc2CheckDataDto().prospect.status + '&fone=' + nc2CheckDataDto().prospect.fone + '&ramal=' + ramal;
  var xhttp = new XMLHttpRequest();

  
  //Incrementa sequencia
  nc2IncrementaSequence();

  xhttp.open("GET", urlInformaMotivoPausa, false);
  xhttp.send();   

  //Trata resposta    
  if (xhttp.readyState == 4 && xhttp.status == 200) {          
      return true;
   }
}


  function nc2Login(pRamal) {   


      // nc2MonitoraService(pRamal);

      //Obtem info do operador pelo ramal
      nc2ObterOperador(pRamal);

      if(nc2CheckLogin(pRamal)){       
        
        nc2Logoff(pRamal);
        
        nc2ObterOperador(pRamal); 

      }

      //Loga no cloud
      localStorage.setItem('loginCloud',nc2LoginCloud(nc2Operador().nome,nc2Operador().senha != null ? nc2Operador().senha : ''));

      if (loginCloud()) {
        //Loga no core
        localStorage.setItem('loginCore', nc2LoginCore(pRamal));
      }
      
      
      if (loginCloud() && loginCore()) {
        localStorage.setItem('nc2Logado',true);

        localStorage.setItem('isCheckData',true);
      }else{

        if (loginCloud()) {
          nc2LogoffCloud();
        }

        if (loginCore()) {
          nc2LogoffCore();
        }

        //Trata erro no login
        toast.info('Erro no login do Discador', {
          position: "bottom-right",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });

        setTimeout(() => {
          document.location.reload(true)
        }, 3000)
      }
    
  }
  
  function nc2LoginCore(pRamal){
    //Define variaveis
    var urlLogin;
    var objResponse;
    var request = new XMLHttpRequest();
    
    //monta url do login
    //urlLogin = NC2_URL + '?jsonMsg={"sequence":' + nc2Seq + ',"type":1000,"arguments":{"codigoOperador":"' + operador.idOperador + '","pa":"' + operador.pa + '","ramal":"'+ pRamal +'","ramalFisico":"","ip":"","gravando":"","callback":"'+ NC2_URL_CALLBACK +'"}}';
    urlLogin = NC2_URL + '?jsonMsg={"sequence":' + localStorage.getItem('nc2Seq') + ',"type":1000,"arguments":{"codigoOperador":"' + nc2Operador().idOperador + '","pa":"' + nc2Operador().pa + '","ramal":"'+ pRamal +'","callback":"'+ NC2_URL_CALLBACK +'"}}';
  
    //Chama url de login    
    request.open('GET', urlLogin, false);  
    request.send(null);
  
    //Trata resposta
    if (request.readyState == 4 && request.status === 200) {
        
        objResponse = JSON.parse(unescape(request.responseText));

  
        localStorage.setItem('nc2SessionKey', objResponse.id);
        nc2IncrementaSequence();
  
        return true;
    }else{
      return false;
    }
  }

  function nc2CheckLogin(pRamal){
    //Define variaveis
    var urlLogin;
    var objResponse;
    var request = new XMLHttpRequest();

    //monta url do login    
    urlLogin = NC2_URL + '?jsonMsg={"sequence":' + localStorage.getItem('nc2Seq') + ',"type":1998,"arguments":{"codigoOperador":"' + nc2Operador().idOperador + '","ramal":"'+ pRamal +'"}}';

    //Chama url de login    
    request.open('GET', urlLogin, false);  
    request.send(null);

    //Trata resposta
    if (request.status === 200) {
        
        objResponse = JSON.parse(unescape(request.responseText));


        if(objResponse.code == 5){

            localStorage.setItem('nc2SessionKey', objResponse.id);
            nc2IncrementaSequence();

            localStorage.setItem('loginCloud',true);
            localStorage.setItem('loginCore', true);

            return true;
        }else{
            return false;
        }
    }
}
  
  function nc2LoginCloud(login,senha){
    var data = null;
  
    var xhr = new XMLHttpRequest();

    
    xhr.open("POST", NC2_URL_LOGIN_CLOUD + '?login=' + login + '&senha='+senha,false);
    
    
    xhr.send(data);
    
    if (xhr.readyState === 4 && xhr.status == 200) {
        return true;
    }else{
      return false;
    }   
  
  }
  
  function nc2ObterOperador(ramal){

  
    var request = new XMLHttpRequest();
    request.open('GET', NC2_URL_OPERADOR + ramal, false);  
    request.send(null);
    

    if (request.status === 200) {        
      localStorage.setItem('operador', JSON.stringify(JSON.parse(request.responseText).dto));
    }
  
  }
  
  function nc2ObterResultados(dispatch){

  
    var request = new XMLHttpRequest();
    request.open('GET', NC2_URL_RESULTADOS + nc2CheckDataDto().operador.projeto.idProjeto, false);  
    request.send(null);
    

    if (request.status === 200) {        
      localStorage.setItem('nc2Resultados', JSON.stringify(JSON.parse(request.responseText).dtoList));
      dispatch(nc2ScheduleReasonsUser(JSON.parse(request.responseText).dtoList))
    }
  

  }

  function nc2ObterTelefones(dispatch){

  
    var request = new XMLHttpRequest();
    request.open('GET', NC2_URL_TELEFONES + nc2CheckDataDto().prospect.idProspect, false);  
    request.send(null);
    

    if (request.status === 200) {        
      localStorage.setItem('nc2Telefones', JSON.stringify(JSON.parse(request.responseText).dtoList));
      dispatch(nc2ScheduleNumbersUser(JSON.parse(request.responseText).dtoList))
    }
    
  }

  function nc2AlteraStatus(ramal,codigoStatus){    
  
    //Define variaveis
    var urlAlteraStatus = NC2_URL + '?sessionKey=' + localStorage.getItem('nc2SessionKey') + '&jsonMsg={"sequence":"' + localStorage.getItem('nc2Seq') + '","type":1001,"arguments":{"ramal":"' + ramal + '","status":"' + codigoStatus + '","statusFone":"' + codigoStatus + '"}}';
    var xhttp = new XMLHttpRequest();
    
    //Incrementa sequencia
    nc2IncrementaSequence();
  
    xhttp.open("GET", urlAlteraStatus, false);
    xhttp.send();

    if(codigoStatus == '2'){
        toast.dismiss();
        localStorage.setItem('fone',0);
        localStorage.setItem('isCheckData',false); 
    }
    
    if (xhttp.readyState == 4 && xhttp.status == 200) {   
      if(codigoStatus == '0')
        localStorage.setItem('isCheckData',true);   
      
      if(codigoStatus == '1')
        localStorage.setItem('isCheckData',false);      
        
        return true;
    }
   
  }
  
  function nc2GravaFimPausa(ramal,tempoPausa){    
		//Define variaveis
		var urlInformaMotivoPausa = NC2_URL + '?sessionKey=' +  localStorage.getItem('nc2SessionKey') + '&jsonMsg={"sequence":"' + localStorage.getItem('nc2Seq') + '","type":1026,"arguments":{"ramal":"' + ramal + '","projeto":"' + nc2CheckDataDto().operador.projeto.idProjeto + '","codigoOperador":"' + nc2CheckDataDto().operador.idOperador  + '","motivo":302,"equipe":"' + nc2CheckDataDto().operador.idEquipe + '","tempo":"' +  + '"}}';
    var xhttp = new XMLHttpRequest();
    
		
		//Incrementa sequencia
		nc2IncrementaSequence();

		//Trata resposta
		xhttp.addEventListener("readystatechange", function () {
			if (xhttp.readyState == 4 && xhttp.status == 200) {          
			  return true
			}
		});

		xhttp.open("GET", urlInformaMotivoPausa, true);
		xhttp.send();

   
	}
  
  function nc2Logoff(ramal){
  
    if(nc2Operador() !== null){
        //logout no core
        nc2LogoffCore(ramal);
        
        // logoff no cloud
        nc2LogoffCloud(ramal);
  
        //reseta variaveis
        localStorage.setItem('nc2SessionKey', '');
        localStorage.setItem('nc2Seq', 1);
        localStorage.setItem('operador', null);
        localStorage.setItem('nc2Logado', false);
        localStorage.setItem('isCheckData', true);
        localStorage.setItem('isCheckMessage', true);
        localStorage.setItem('nc2CheckDataDto', null);
        localStorage.setItem('nc2UserData', null);
        localStorage.setItem('checkDataTimer', null);
        localStorage.setItem('mensagemTimer', null);
        localStorage.setItem('nc2Resultados', false);
        localStorage.setItem('nc2Telefones', false);

        //clearInterval(checkDataTimer);
        //clearInterval(mensagemTimer);
        return true;
    }
  };
  
  function nc2LogoffCore(ramal) {
    //Define variaveis 
    var urlLogoff = NC2_URL + unescape('?jsonMsg=' + unescape('{"sequence":' + localStorage.getItem('nc2Seq') + ',"type":1999,"arguments":{"codigoOperador":"' + nc2Operador().idOperador + '","pa":"' + nc2Operador().pa + '","ramal":"' + ramal + '"}}'));
    var xhttp = new XMLHttpRequest();
    
    //Trata resposta
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        //Reinicia variaveis
        //nc2Seq = 1;
        //nc2SessionKey = '';
        //operador = null;
  
        return true
      }
    };
    xhttp.open("GET", urlLogoff, true);
    xhttp.send();
  }
  
  function nc2LogoffCloud(ramal) {
    var data = null;
  
    var xhr = new XMLHttpRequest();
    
    xhr.open("GET", NC2_URL_LOGOFF_CLOUD + '?ramal=' + ramal);
    
    
    xhr.send(data);
    
    if (xhr.readyState === 4) {
        return true;
    } 
    
  }

  function nc2InformaMotivoPausa(ramal,descricaoMotivo){    
    //Define variaveis
    var urlInformaMotivoPausa = NC2_URL + '?sessionKey=' + localStorage.getItem('nc2SessionKey') + '&jsonMsg={"sequence":"' + localStorage.getItem('nc2Seq') + '","type":1027,"arguments":{"ramal":"' + ramal + '","pausa":"2","motivo":"' + descricaoMotivo + '"}}';
    var xhttp = new XMLHttpRequest();
    
    //Incrementa sequencia
    nc2IncrementaSequence();

    //Trata resposta
    xhttp.addEventListener("readystatechange", function () {
        if (xhttp.readyState == 4 && xhttp.status == 200) {          
          return true
        }
    });

    xhttp.open("GET", urlInformaMotivoPausa, true);
    xhttp.send();
   
  }

  function nc2ReconectarService(pRamal){
    
    nc2Logoff(pRamal);

    nc2Login(pRamal);

  }

  function nc2IncrementaSequence() {
    localStorage.setItem('nc2Seq',JSON.parse(localStorage.getItem('nc2Seq')) + 1);
  }
  
  function nc2Operador() {
    return localStorage.getItem('operador') != null ? JSON.parse(localStorage.getItem('operador')) : null; 
  }

  function nc2CheckDataDto() {
    return localStorage.getItem('nc2CheckDataDto') != null ? JSON.parse(localStorage.getItem('nc2CheckDataDto')) : null; 
  }

  function nc2UserData() {
    return localStorage.getItem('nc2UserData') != null ? JSON.parse(localStorage.getItem('nc2UserData')) : null; 
  }

  function nc2Logado() {
    return JSON.parse(localStorage.getItem('nc2Logado')) ; 
  }

  function isCheckData() {
    return JSON.parse(localStorage.getItem('isCheckData')) ; 
  }

  function isCheckMessage() {
    return JSON.parse(localStorage.getItem('isCheckMessage')) ; 
  }

  function loginCloud() {
    return JSON.parse(localStorage.getItem('loginCloud')) ; 
  }

  function loginCore() {
    return JSON.parse(localStorage.getItem('loginCore')) ; 
  }

  



var wnc2service = {
    nc2Login: nc2Login,
    nc2Logoff: nc2Logoff,
    nc2LogoffCloud: nc2LogoffCloud,
    nc2LogoffCore: nc2LogoffCore,
    nc2LoginCloud: nc2LoginCloud,
    nc2LoginCore: nc2LoginCore,
    nc2AlteraStatus: nc2AlteraStatus,
    nc2InformaMotivoPausa: nc2InformaMotivoPausa,
    nc2EncerraContato: nc2EncerraContato,
    nc2AtualizaProspect: nc2AtualizaProspect,
    nc2GravaFimPausa: nc2GravaFimPausa,
    nc2CheckLogin: nc2CheckLogin,
    nc2MonitoraService: nc2MonitoraService,
    nc2ObterTelefones: nc2ObterTelefones,
    nc2ObterResultados: nc2ObterResultados
};

return wnc2service;
})();
window.nc2Service = nc2Service;

export default nc2Service;
